import React, {Component} from 'react'

import {connect} from 'react-redux'
import {createStructuredSelector} from "reselect"
import ReferralQuestionTitleWillYouSelect
  from "manager/views/components/ReferralStatus/ReferralQuestionTitleWillYouSelect"
import ReferralQuestionTitleWhoIsProvider
  from "manager/views/components/ReferralStatus/ReferralQuestionTitleWhoIsProvider"
import ReferralQuestionTitlePlacedOrder from "manager/views/components/ReferralStatus/ReferralQuestionTitlePlacedOrder"
import {
  selectAssignmentTransactionHash,
  selectLatestQualiaOrder,
  selectReferralQualiaAskAgentQuestion,
  selectReferralQualiaEnabled,
  selectTitleDoYouKnowProviderQuestion,
  selectTitlePlacedOrderQuestion,
  selectTitleProviderIsQualia,
  selectTitleWhoIsProviderQuestion,
  selectTitleWillYouSelectQuestion,
  selectTransactionType
} from "manager/selectors/referral_selectors"
import {
  AGENT_STATUS_CLOSED,
  AGENT_STATUS_CONTRACT,
  AGENT_STATUS_OFFER,
  ANSWER_TYPE,
  QUESTION_TYPE,
} from "common/constants"
import {selectSelectedTitleCompany,} from "manager/selectors/referral_status_selectors"
import {updateAgentTitleQuestions} from "manager/redux/referral"
import ReferralQuestionTitleDoYouKnowProvider
  from "manager/views/components/ReferralStatus/ReferralQuestionTitleDoYouKnowProvider"
import {
  CLOSE_SPEED_BUMP_MESSAGE_TITLE_NOT_SELECTED,
  CLOSE_SPEED_BUMP_MESSAGE_TITLE_SELECTED,
  CONTRACT_SPEED_BUMP_MESSAGE,
  OFFER_SPEED_BUMP_MESSAGE,
  TITLE_SPEED_BUMP_OPT_OUT
} from "manager/views/components/ReferralStatus/Common/constants"
import SpeedBump from "manager/views/components/ReferralStatus/Common/SpeedBump"
import ReferralQuestionTitlePlaceOrderNow
  from "manager/views/components/ReferralStatus/ReferralQuestionTitlePlaceOrderNow"
import {selectSearchConfigIsPlaceOrderNowSupported} from "manager/selectors/settlement_provider_search_selectors"

class ReferralQualiaQuestions extends Component {
  state = {
    local_selection_who_is_provider: null,
    optedOut: false
  }

  setLocalSelectionWhoIsProvider = (local_selection_who_is_provider) => {
    this.setState({local_selection_who_is_provider})
  }

  onOptOut = () => {
    this.setState({optedOut: true})
  }

  componentWillMount() {
    const {titleWillYouSelectAnswer, titleDoYouKnowProviderAnswer, selectedTitleCompany, titlePlacedOrderAnswer, updateAgentTitleQuestions, editStatus, shouldAskAgentQuestion, isReferralQualiaEnabled} = this.props
    const titleWillYouSelectAnswerNo = titleWillYouSelectAnswer && titleWillYouSelectAnswer[ANSWER_TYPE.YES_NO] !== 'yes'

    // clear subsequent answers if titleWillYouSelectAnswer is no or not-sure
    if (titleWillYouSelectAnswerNo && titleDoYouKnowProviderAnswer) {
      updateAgentTitleQuestions({[QUESTION_TYPE.TITLE_DO_YOU_KNOW_PROVIDER]: null})
    }

    // clear subsequent answers if titleWillYouSelectAnswer is no or not-sure or selectedTitleCompany is null
    if ((titleWillYouSelectAnswerNo || !selectedTitleCompany) && titlePlacedOrderAnswer){
      updateAgentTitleQuestions({[QUESTION_TYPE.TITLE_PLACED_ORDER]: null})
    }

    //clear titleWillYouSelectAnswer answer
    if (editStatus===AGENT_STATUS_CLOSED && (!shouldAskAgentQuestion || !isReferralQualiaEnabled) && titleWillYouSelectAnswer) {
      updateAgentTitleQuestions({[QUESTION_TYPE.TITLE_WILL_YOU_SELECT]: null})
    }
  }

  onOptOut = () => {
    this.setState({optedOut: true})
  }

  render() {
    const {hash, isSelectedQualiaProvider, titleWillYouSelectAnswer, titlePlacedOrderAnswer, titleDoYouKnowProviderAnswer, titleWhoIsProviderAnswer, shouldAskAgentQuestion, isReferralQualiaEnabled, transactionType, editStatus, qualia_order, selectedTitleCompany, searchConfigIsPlaceOrderNowSupported} = this.props
    const {local_selection_who_is_provider} =  this.state

    const isQualiaSupported= selectedTitleCompany && selectedTitleCompany.id

    const agentStatusOffer = editStatus === AGENT_STATUS_OFFER
    const agentStatusContract = editStatus === AGENT_STATUS_CONTRACT
    const agentStatusClosed = editStatus === AGENT_STATUS_CLOSED

    const titleWillYouSelectAnswerYes = titleWillYouSelectAnswer && titleWillYouSelectAnswer[ANSWER_TYPE.YES_NO] === 'yes'
    const titleDoYouKnowProviderAnswerYes = titleDoYouKnowProviderAnswer && titleDoYouKnowProviderAnswer[ANSWER_TYPE.YES_NO] === 'yes'

    const includeWillYouSelectQuestion = agentStatusClosed ? (shouldAskAgentQuestion && isReferralQualiaEnabled && transactionType !== 'lease') :  (shouldAskAgentQuestion && transactionType !== 'lease')
    const includeQualiaQuestion = shouldAskAgentQuestion && transactionType !== 'lease' && isReferralQualiaEnabled
    const includeDoYouKnowProviderQuestion = includeQualiaQuestion && agentStatusOffer && titleWillYouSelectAnswerYes
    const includeWhoIsProviderQuestion = includeQualiaQuestion && (
      (agentStatusOffer && titleWillYouSelectAnswerYes && titleDoYouKnowProviderAnswerYes) ||
      (agentStatusContract && titleWillYouSelectAnswerYes && !qualia_order) ||
      (agentStatusClosed)
    )
    const titlePlacedOrderAnswerYes = titlePlacedOrderAnswer && titlePlacedOrderAnswer[ANSWER_TYPE.YES_NO] === 'yes'
    const titlePlacedOrderAnswerNo = titlePlacedOrderAnswer && titlePlacedOrderAnswer[ANSWER_TYPE.YES_NO] === 'no'
    const includePlacedOrderQuestion = includeQualiaQuestion && agentStatusContract && titleWillYouSelectAnswerYes && titleWhoIsProviderAnswer && isQualiaSupported
    const includePlaceOrderNowQuestion = agentStatusContract && titleWillYouSelectAnswerYes && includeQualiaQuestion && isSelectedQualiaProvider && titlePlacedOrderAnswerNo && searchConfigIsPlaceOrderNowSupported && !qualia_order

    const localStorageKey = TITLE_SPEED_BUMP_OPT_OUT.concat('_', hash)

    const getMessage = () => {
      const selectedQualiaButNotYetPlacedOrder = isSelectedQualiaProvider && !qualia_order
      if (agentStatusOffer && titleWillYouSelectAnswerYes && titleDoYouKnowProviderAnswerYes && selectedQualiaButNotYetPlacedOrder) {
        return OFFER_SPEED_BUMP_MESSAGE
      }
      else if (agentStatusContract && titleWillYouSelectAnswerYes && titlePlacedOrderAnswerYes && selectedQualiaButNotYetPlacedOrder) {
        return CONTRACT_SPEED_BUMP_MESSAGE
      }
      else if (agentStatusClosed && selectedQualiaButNotYetPlacedOrder) {
        if(titleWillYouSelectAnswerYes){
          return CLOSE_SPEED_BUMP_MESSAGE_TITLE_SELECTED
        } else {
          return CLOSE_SPEED_BUMP_MESSAGE_TITLE_NOT_SELECTED
        }
      }
      return null
    }

    return (
      <div>
        {
          includeWillYouSelectQuestion &&
          <ReferralQuestionTitleWillYouSelect editStatus={editStatus}/>
        }
        {
          includeDoYouKnowProviderQuestion &&
          <ReferralQuestionTitleDoYouKnowProvider/>
        }
        {
          includeWhoIsProviderQuestion &&
          <ReferralQuestionTitleWhoIsProvider
            editStatus={editStatus}
            setLocalSelectionWhoIsProvider={this.setLocalSelectionWhoIsProvider}
            local_selection_who_is_provider={local_selection_who_is_provider}
          />
        }
        {
          includePlacedOrderQuestion &&
          <ReferralQuestionTitlePlacedOrder/>
        }

        {
          includePlaceOrderNowQuestion &&
          <ReferralQuestionTitlePlaceOrderNow
            local_selection_who_is_provider={local_selection_who_is_provider}
          />
        }

        {getMessage() && !this.state.optedOut &&
            <SpeedBump
              localStorageKey={localStorageKey}
              message={getMessage()}
              showOptOutLink={true}
              onOptOutClick={this.onOptOut}/>}
      </div>
    )
  }
}

const selector = createStructuredSelector({
  shouldAskAgentQuestion: selectReferralQualiaAskAgentQuestion,
  transactionType: selectTransactionType,
  isReferralQualiaEnabled: selectReferralQualiaEnabled,
  titleWillYouSelectAnswer: selectTitleWillYouSelectQuestion,
  titleDoYouKnowProviderAnswer: selectTitleDoYouKnowProviderQuestion,
  titleWhoIsProviderAnswer: selectTitleWhoIsProviderQuestion,
  titlePlacedOrderAnswer: selectTitlePlacedOrderQuestion,
  qualia_order: selectLatestQualiaOrder,
  selectedTitleCompany: selectSelectedTitleCompany,
  hash: selectAssignmentTransactionHash,
  isSelectedQualiaProvider: selectTitleProviderIsQualia,
  searchConfigIsPlaceOrderNowSupported: selectSearchConfigIsPlaceOrderNowSupported,
})

const actions = {
  updateAgentTitleQuestions,
}

export default connect(selector, actions)(ReferralQualiaQuestions)

